import {ScratchAudio} from '@hetao/scratch-core';
import PropTypes from 'prop-types';
import React from 'react';
import {VM} from '@hetao/scratch-core';
import {connect} from 'react-redux';
import bindAll from 'lodash.bindall';

import ReactModal from 'react-modal';

import {polyfill} from 'es6-promise';
polyfill();
import 'isomorphic-fetch';
import '../utils/patchGetBoundingClientRect.js';

import ErrorBoundaryHOC from '../lib/error-boundary-hoc.jsx';
import {openExtensionLibrary} from '../reducers/modals';
import log from '../lib/log';
import {isTeacherMode, isTutor} from '../lib/hetao-mode';

import {
    closeCostumeLibrary,
    closeBackdropLibrary,
    closeVideoGuide,
    closeBackWithoutSubmit
} from '../reducers/modals';

import {setTargetState} from '../reducers/vm-status.js';
import {notifyMenuBarLoaded} from '../lib/app/api';
import ProjectLoaderHOC from '../lib/project-loader-hoc.jsx';
import vmListenerHOC from '../lib/vm-listener-hoc.jsx';

import GUIComponent from '../components/gui/gui.jsx';

import {getHomeworkInfo} from '../lib/homework-info';
import scratchTester from '../lib/scratch-tester'

// const messages = defineMessages({
//     loadError: {
//         id: 'gui.projectLoader.loadError',
//         defaultMessage: 'The project file that was selected failed to load.',
//         description: 'An error that displays when a local project file fails to load.'
//     }
// });
const AudioEngine = ScratchAudio;
const doThisOnSaveProjectFileBegin = vm => {
// 在涉及项目文件保存，自动保存，提交时触发的检测当前项目json文件的角色的造型索引匹配情况，
    // 因为之前出现过当前索引大于所拥有的最大索引值，出bug @author 覃京宁 20181116
    let costumeIndexOversize = false;
    const saPoint = {};
    vm.runtime.targets.forEach((target, i) => {
        if (target.currentCostume > 0 && target.currentCostume > target.sprite.costumes_.length - 1) {
            // 此时出现了角色中的当前造型索引大于该角色所拥有的造型索引最大值，
            // 可能出现的原因猜测是用户网络环境差造型图片请求时出现错误
            // 导致造型下载不全，这种情况需要记录一下，并帮用户纠正索引错误，避免下次打开项目文件时崩溃
            costumeIndexOversize = true;
            saPoint[`target_index_${i}`] = {
                target_id: target.id,
                current_costume: target.currentCostume,
                sprite_name: target.sprite.name,
                costumes_length: target.sprite.costumes_.length,
                costumes_list: target.sprite.costumes_
            };
            // 纠正用户json
            target.currentCostume = target.sprite.costumes_.length - 1 < 0 ?
                0 : target.sprite.costumes_.length - 1;
            log.info('出现了造型索引大于该角色索引最大值的情况');
        }
    });
    if (costumeIndexOversize) {
        const homeworkInfo = getHomeworkInfo();
        if (!window.sa) {
            return;
        }
        window.sa.track('s3_costume_index_oversize', {
            course_id: homeworkInfo.courseId,
            lesson_id: homeworkInfo.lessonId,
            unit_id: homeworkInfo.unitId,
            scratch_info: JSON.stringify(saPoint)
        });
    }
};
class GUI extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            loading: !props.vm.initialized,
            loadingError: false,
            errorMessage: '',
            isScratchTesterVisible: false
        };
        bindAll(this, ['checkAndReorderDroppingIndexes']);
    }
    componentDidMount () {
        // if (this.props.projectTitle) {
        //     this.props.onUpdateReduxProjectTitle(this.props.projectTitle);
        // }
        document.documentElement.style.background = 'initial';
        if (this.props.vm.initialized) return;
        this.audioEngine = new AudioEngine();
        this.props.vm.attachAudioEngine(this.audioEngine);
        this.props.vm.loadProject(this.props.projectData)
            .then((zip) => zip && scratchTester.loadProject(zip))
            .then(() => {
                this.setState({loading: false}, () => {
                    this.props.vm.setCompatibilityMode(true);
                    this.props.vm.start();
                    notifyMenuBarLoaded();
                });
                if (isTutor()) {
                    const loadEndTime = (new Date()).getTime();
                    sa.track('tutor_view_homework_load_time', {
                        context: {
                            current_url: window.location.href,
                            load_time: loadEndTime - window.startLoadPageTime
                        }
                    });
                    ht.track('tutor_view_homework_load_time', {
                        context: {
                            current_url: window.location.href,
                            load_time: loadEndTime - window.startLoadPageTime
                        }
                    });
                }
            })
            .catch(e => {
                // 仍然要start否则点重做仍然会是黑屏
                // this.props.vm.setCompatibilityMode(true);
                // this.props.vm.start();
                window.parent.postMessage({isLoadingProjectError: true}, '*');
                window.confirm('加载作品文件失败'); // eslint-disable-line no-alert
                sa.track('s3_project_open_failed');
                this.setState({loading: false});
                log.error(e);
            });
        this.props.vm.initialized = true;

        this.props.vm.on('saveProjectSb3Begin', () => {
            doThisOnSaveProjectFileBegin(this.props.vm);
        });
        this.props.vm.on('workspaceUpdate', this.checkAndReorderDroppingIndexes);

        document.addEventListener('keydown', (e) => {
            if ((e.ctrlKey && e.which === 79) || (e.altKey && e.which === 79)) {
                e.preventDefault();
                this.setState({
                    isScratchTesterVisible: !this.state.isScratchTesterVisible
                })
            }
        })

    }
    componentWillReceiveProps (nextProps) {

        if (this.props.projectData !== nextProps.projectData) {
            this.setState({loading: true}, () => {
                this.props.vm.loadProject(nextProps.projectData)
                    .then((zip) => zip && scratchTester.loadProject(zip))
                    .then(() => {
                        this.setState({loading: false});
                    })
                    .catch(e => {
                        window.parent.postMessage({isLoadingProjectError: true}, '*');
                        window.confirm('加载作品文件失败'); // eslint-disable-line no-alert
                        sa.track('s3_project_open_failed');
                        this.setState({loading: false});
                        log.error(e);
                    });
            });
        }

        // if (this.props.projectTitle !== nextProps.projectTitle) {
        //     this.props.onUpdateReduxProjectTitle(nextProps.projectTitle);
        // }
    }
    componentDidUpdate () {


        if (!this.props.initVMTargets){

            const initVMTargets = {};

            this.props.vm.runtime.targets.forEach(target => {
                initVMTargets[target.id] = Object.keys(target.blocks._blocks);

            });
            this.props.onInitializeVMTargets(initVMTargets);

        }

    }

    componentWillUnmount () {
        this.props.vm.removeListener('workspaceUpdate', this.checkAndReorderDroppingIndexes);
    }

    /**
     * 检查 droppingIndex 是否缺失并根据需要重新排序
     * 为了兼容旧 sb3 文件
     */
    checkAndReorderDroppingIndexes() {
        if (!isTeacherMode()) {
            return;
        }
        const workspace = Blockly.getMainWorkspace();
        if (!workspace) {
            return;
        }

        // 只要有一个 block 的 droppingIndex 不存在，就会被判为旧 sb3 文件，需要重新设置 droppingIndex
        const missingIndexBlock = workspace.getAllBlocks().find(block => {
            const droppingIndex = block.getDroppingIndex();

            // 不需要 droppingIndex 的 block
            if (Blockly.noDroppingIndexBlocks.includes(block.type)) {
                return false;
            }

            // 阴影块不需要 droppingIndex
            if (block.isShadow()) {
                return false;
            }

            return droppingIndex === null || droppingIndex === undefined;
        });

        if (missingIndexBlock) {
            workspace.reorderDroppingIndex();
            console.warn(`${missingIndexBlock.type} 的 droppingIndex 不存在`, missingIndexBlock);
        }
    }

    render () {

        if (this.state.loadingError) {
            throw new Error(
                `Failed to load project from server [id=${window.location.hash}]: ${this.state.errorMessage}`);
        }
        const {
            /* eslint-disable no-unused-vars */
            assetHost,
            hideIntro,
            onUpdateReduxProjectTitle,
            projectData,
            projectHost,
            projectTitle,
            /* eslint-enable no-unused-vars */
            children,
            fetchingProject,
            loadingStateVisible,
            vm,
            ...componentProps
        } = this.props;
        return (
            <GUIComponent
                loading={fetchingProject || this.state.loading || loadingStateVisible}
                vm={vm}
                isScratchTesterVisible={this.state.isScratchTesterVisible}
                {...componentProps}
            >
                {children}
            </GUIComponent>
        );
    }
}

GUI.propTypes = {
    // ...GUIComponent.propTypes,
    assetHost: PropTypes.string,
    children: PropTypes.node,
    closeCallback: PropTypes.func,
    confirmVisible: PropTypes.bool,
    fetchingProject: PropTypes.bool,
    hideIntro: PropTypes.bool,
    // importInfoVisible: PropTypes.bool,
    initVMTargets: PropTypes.objectOf(PropTypes.array),
    loadingStateVisible: PropTypes.bool,
    loginInfoVisible: PropTypes.bool,
    maskLayerVisible: PropTypes.bool,
    // onSeeCommunity: PropTypes.func,
    onInitializeVMTargets: PropTypes.func,
    onUpdateProjectTitle: PropTypes.func,
    onUpdateReduxProjectTitle: PropTypes.func,
    previewInfoVisible: PropTypes.bool,
    projectData: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    projectHost: PropTypes.string,
    projectTitle: PropTypes.string,
    textConfirm: PropTypes.string,
    vm: PropTypes.instanceOf(VM)

};

GUI.defaultProps = GUIComponent.defaultProps;

const mapStateToProps = state => ({
    activeTabIndex: state.scratchGui.editorTab.activeTabIndex,
    // alertsVisible: state.scratchGui.alerts.visible,
    backdropLibraryVisible: state.scratchGui.modals.backdropLibrary,
    // blocksTabVisible: state.scratchGui.editorTab.activeTabIndex === BLOCKS_TAB_INDEX,
    cardsVisible: state.scratchGui.cards.visible,
    costumeLibraryVisible: state.scratchGui.modals.costumeLibrary,
    importInfoVisible: state.scratchGui.modals.importInfo,
    isPlayerOnly: state.scratchGui.mode.isPlayerOnly,
    // isRtl: state.locales.isRtl,
    loadingStateVisible: state.scratchGui.modals.loadingProject,
    maskLayerVisible: state.scratchGui.modals.maskLayer,
    previewInfoVisible: state.scratchGui.modals.previewInfo,
    // targetIsStage: (
    //     state.scratchGui.targets.stage &&
    //     state.scratchGui.targets.stage.id === state.scratchGui.targets.editingTarget
    // ),
    // soundsTabVisible: state.scratchGui.editorTab.activeTabIndex === SOUNDS_TAB_INDEX,
    tipsLibraryVisible: state.scratchGui.modals.tipsLibrary,
    finishHomeworkWarnVisible: state.scratchGui.modals.finishHomework,
    whitelistVisible: state.scratchGui.modals.whiteList,
    uploadProgressVisible: state.scratchGui.modals.uploadHomeworkProgress,
    loginInfoVisible: state.scratchGui.modals.loginInfo,
    videoGuideVisible: state.scratchGui.modals.videoGuide,
    backWithoutSubmitVisible: state.scratchGui.modals.backWithoutSubmit,
    initVMTargets: state.scratchGui.vmStatus.initVMTargets
});

const mapDispatchToProps = dispatch => ({
    // onActivateTab: tab => dispatch(activateTab(tab)),
    // onActivateCostumesTab: () => dispatch(activateTab(COSTUMES_TAB_INDEX)),
    // onActivateSoundsTab: () => dispatch(activateTab(SOUNDS_TAB_INDEX)),
    onExtensionButtonClick: () => dispatch(openExtensionLibrary()),
    onRequestCloseBackdropLibrary: () => dispatch(closeBackdropLibrary()),
    onRequestCloseCostumeLibrary: () => dispatch(closeCostumeLibrary()),
    onRequestCloseVideoGuide: () => dispatch(closeVideoGuide()),
    onRequestCloseBackWithoutSubmit: () => dispatch(closeBackWithoutSubmit()),
    onInitializeVMTargets: initVMTargets => dispatch(setTargetState(initVMTargets))
    // onUpdateReduxProjectTitle: title => dispatch(setProjectTitle(title))
});

const ConnectedGUI = connect(
    mapStateToProps,
    mapDispatchToProps,
)(GUI);

//是否是从Crm的备课进入，目前 判断url中是否包含staffId,teacherId,unitId,chapterId，形如：/?staffId=19642&teacherId=30006810&unitId=25247&t=1658461709&chapterId=756021
const isFromBeiKe  = (function () {
    const searchKeys = [...new URLSearchParams(location.search).keys()];
    return ['staffId','teacherId','unitId','chapterId'].every(key => searchKeys.includes(key));
}());
let HocedGUI =  ProjectLoaderHOC(vmListenerHOC(ConnectedGUI));
if (isFromBeiKe) {  
    const BeiKeHOC = require('../lib/beike/service-hoc.jsx').default;
    HocedGUI = BeiKeHOC(HocedGUI);
}
const WrappedGui = ErrorBoundaryHOC('Top Level App')(
    HocedGUI
);
WrappedGui.setAppElement = ReactModal.setAppElement;
export default WrappedGui;
